import { graphql } from "@/lib/gql/__generated__";

export const SnackUpdate_SnackPage_Mutation = graphql(`
	mutation SnackUpdate_SnackPage($input: SnackInput!) {
		snackUpdate(input: $input) {
			userErrors
			snack {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
	}
`);
